import { Translate } from 'next-translate';

import { truncate } from '@utils/strings';

export const NAME_LENGTH_LIMIT = 165;

export const EXCEL_MAX_FILENAME_LIMIT = 207;

/**
 * Generates a OS compliant filename that combines a i18n key and an event name.
 * 
 * @param eventName 
 * @param i18nKey
 * @param t 
 * @returns 
 */
export const generateFileName = (eventName: string, i18nKey: string, t: Translate): string => {
  const cleanEventName = truncate(eventName, NAME_LENGTH_LIMIT, '');

  return t(i18nKey, { name: cleanEventName });
};
